import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import PetsIcon from "@mui/icons-material/Pets";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import { RUTA_PROPIETARIOS, RUTA_MASCOTAS } from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-3">
              {puedeAccederRuta(usuario, RUTA_PROPIETARIOS) && (
                <CardCol>
                  <MenuItemCard
                    Icono={ContactPageIcon}
                    ruta={RUTA_PROPIETARIOS}
                    titulo="Propietarios"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_MASCOTAS) && (
                <CardCol>
                  <MenuItemCard
                    Icono={PetsIcon}
                    ruta={RUTA_MASCOTAS}
                    titulo="Mascotas"
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={4} sm={6}>
      {children}
    </Col>
  );
};
export default CardSection;
